const RESTORE_ERROR_OVERRIDES = {
  404: 'Elemento non più nel cestino.',
  code0: 'Ripristino non riuscito.',
}

const isPlainObject = value => typeof value === 'object' && value !== null && !Array.isArray(value)

const uniqueIds = ids => {
  if (!Array.isArray(ids)) {
    return []
  }
  const seen = []
  ids.forEach(id => {
    if (id === null || id === undefined) {
      return
    }
    if (!seen.includes(id)) {
      seen.push(id)
    }
  })
  return seen
}

const classifyFulfilled = value => {
  const data = value && isPlainObject(value) ? value.data : null
  const code = data && isPlainObject(data) ? Number(data.code) : NaN
  if (code === 1) {
    const restored = data.data
    const object = restored && isPlainObject(restored) ? restored : null
    return { outcome: 'restored', object }
  }
  return { outcome: 'not_restored', failure: value }
}

const classifyRejected = reason => {
  const status = reason && isPlainObject(reason.response) && typeof reason.response.status === 'number'
    ? reason.response.status
    : null
  if (status === 404) {
    return { outcome: 'not_in_trash', failure: reason }
  }
  if (status === 403) {
    return { outcome: 'forbidden', failure: reason }
  }
  return { outcome: 'error', failure: reason }
}

const classifyRestoreResult = settled => {
  if (settled && settled.status === 'fulfilled') {
    return classifyFulfilled(settled.value)
  }
  if (settled && settled.status === 'rejected') {
    return classifyRejected(settled.reason)
  }
  return { outcome: 'error', failure: settled }
}

const OUTCOME_LABELS = {
  not_in_trash: 'non più nel cestino',
  forbidden: 'permesso negato',
  not_restored: 'ripristino non riuscito',
  error: 'con errore',
}

const summarizeRestoreResults = (ids, results) => {
  if (!Array.isArray(ids) || ids.length === 0) {
    return {
      restoredObjects: [], failures: [], toast: null, singleFailure: null,
    }
  }

  const restoredObjects = []
  const failures = []
  ids.forEach((id, index) => {
    const classified = classifyRestoreResult(results[index])
    if (classified.outcome === 'restored') {
      const { object } = classified
      restoredObjects.push(object && Object.prototype.hasOwnProperty.call(object, 'id') ? object : { id })
    } else {
      failures.push({ id, outcome: classified.outcome, failure: classified.failure })
    }
  })

  if (failures.length === 0) {
    const n = ids.length
    const text = n === 1 ? 'Elemento ripristinato.' : `${n} elementi ripristinati.`
    return {
      restoredObjects,
      failures,
      toast: {
        title: 'Successo!', text, icon: 'CheckIcon', variant: 'success',
      },
      singleFailure: null,
    }
  }

  if (ids.length === 1) {
    return {
      restoredObjects, failures, toast: null, singleFailure: failures[0].failure,
    }
  }

  const counts = {
    restored: restoredObjects.length,
    not_in_trash: 0,
    forbidden: 0,
    not_restored: 0,
    error: 0,
  }
  failures.forEach(failure => {
    counts[failure.outcome] += 1
  })

  const segments = []
  if (counts.restored > 0) {
    segments.push(counts.restored === 1 ? '1 ripristinato' : `${counts.restored} ripristinati`)
  }
  const failureOutcomeOrder = ['not_in_trash', 'forbidden', 'not_restored', 'error']
  failureOutcomeOrder.forEach(outcome => {
    if (counts[outcome] > 0) {
      segments.push(`${counts[outcome]} ${OUTCOME_LABELS[outcome]}`)
    }
  })

  const toast = counts.restored > 0
    ? {
      title: 'Attenzione!', text: segments.join(', '), icon: 'AlertTriangleIcon', variant: 'warning',
    }
    : {
      title: 'Errore!', text: `Nessun elemento ripristinato: ${segments.join(', ')}`, icon: 'XIcon', variant: 'danger',
    }

  return {
    restoredObjects, failures, toast, singleFailure: null,
  }
}

export default {
  RESTORE_ERROR_OVERRIDES,
  uniqueIds,
  classifyRestoreResult,
  summarizeRestoreResults,
}
